import { render, staticRenderFns } from "./ColseTermination.vue?vue&type=template&id=08adb6b6&"
import script from "./ColseTermination.vue?vue&type=script&lang=js&"
export * from "./ColseTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports